import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ResetMFAActionTypes } from "src/app/constants/StoreConstants";

export const ResetMFA = createAction(
  ResetMFAActionTypes.ResetMFA,
  props<{userId: number}>()
);

export const ResetMFASuccess = createAction(
  ResetMFAActionTypes.ResetMFSSuccess,
  props<{result: boolean}>()
);

export const ResetMFAError = createAction(
  ResetMFAActionTypes.ResetMFAError,
  props<{error: HttpErrorResponse}>()
);

export const HasMFA = createAction(
  ResetMFAActionTypes.HasMFA,
  props<{userId: number}>()
);

export const HasMFASuccess = createAction(
  ResetMFAActionTypes.HasMFASuccess,
  props<{result: boolean}>()
);

export const HasMFAError = createAction(
  ResetMFAActionTypes.HasMFAError,
  props<{error: HttpErrorResponse}>()
);

export const ClearResetMFAState = createAction(
  ResetMFAActionTypes.ClearResetMFAState
);